import { HttpService, HttpServiceResponse } from '../shared'
import { OpDayViewAction, OpDayOperAction } from './opday.types'

export class OpDayProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return this.baseUrl
  }

  public view<T>(action: OpDayViewAction, attributes?: Object): Promise<HttpServiceResponse<T>> {
    return this.http.post<T>(`${this.url}/opday_view_api.php?action=${action}`, attributes)
  }

  public oper<T>(action: OpDayOperAction, attributes?: Object): Promise<HttpServiceResponse<T>> {
    return this.http.post<T>(`${this.url}/opday_api.php?action=${action}`, attributes)
  }
}
